import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class ImageService {

    constructor(@Inject(PLATFORM_ID) private _platformId: object) {
    }

    toDataUri(image: HTMLImageElement, canvasWidth: number = 80, canvasHeight: number = 80) {
        if (!isPlatformBrowser(this._platformId)) {
            return null;
        }

        const canvas = document.createElement('canvas');
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        const context = canvas.getContext('2d');

        const originalWidth = image.width;
        const originalHeight = image.height;

        const widthRatio = canvasWidth / originalWidth;
        const heightRatio = canvasHeight / originalHeight;

        let width = 0;
        let height = 0;

        if (originalWidth > originalHeight) {
            height = originalHeight * heightRatio;
            width = (originalWidth / originalHeight) * height;
        } else {
            width = originalWidth * widthRatio;
            height = (originalHeight / originalWidth) * width;
        }

        let xOffset = 0;
        let yOffset = 0;

        if (canvasHeight === height) {
            xOffset = -((width - canvasWidth) / 2);
        } else if (canvasWidth === width) {
            yOffset = -((height - canvasHeight) / 2);
        }

        context.drawImage(image, 0, 0, originalWidth, originalHeight, xOffset, yOffset, width, height);

        return canvas.toDataURL('image/png');
    }

    toFile(dataUri: string) {
        if (!isPlatformBrowser(this._platformId)) {
            return null;
        }

        if (!dataUri) {
            return null;
        }

        const byteString = atob(dataUri.split(',')[1]);
        const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];

        // Write the bytes of the string to an ArrayBuffer.
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let index = 0; index < byteString.length; index++) {
            ia[index] = byteString.charCodeAt(index);
        }

        // Return the new blob.
        const blob: any = new Blob([ab], {type: mimeString});
        blob.lastModifiedDate = new Date();
        blob.name = 'image.png';

        // Cast to a File() type.
        return <File>blob;

    }

}
